import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { WifiOff, AlertCircle, CheckCircle } from "lucide-react";
const NetworkStatus = ({ show = true }) => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [connectionQuality, setConnectionQuality] = useState("good");
  const [showStatus, setShowStatus] = useState(false);
  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setConnectionQuality("good");
      setShowStatus(true);
      setTimeout(() => setShowStatus(false), 3000);
    };
    const handleOffline = () => {
      setIsOnline(false);
      setConnectionQuality("offline");
      setShowStatus(true);
    };
    // Test connection quality periodically
    const testConnection = async () => {
      if (!navigator.onLine) {
        setConnectionQuality("offline");
        return;
      }
      try {
        const start = Date.now();
        // Alterado para um endpoint público e confiável para evitar dependência de backend
        // e garantir um teste de conectividade puro.
        await fetch("https://www.google.com/favicon.ico", {
          method: "HEAD", // HEAD é mais leve que GET
          cache: "no-cache",
          mode: "no-cors", // Essencial para evitar problemas de CORS em um teste de conectividade
          signal: AbortSignal.timeout(5000),
        });
        const duration = Date.now() - start;
        setConnectionQuality(duration > 3000 ? "poor" : "good");
      } catch (error) {
        setConnectionQuality("poor");
      }
    };
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    // Test connection quality every 30 seconds
    const interval = setInterval(testConnection, 30000);
    // Initial test
    testConnection();
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      clearInterval(interval);
    };
  }, []);
  if (!show || (!showStatus && isOnline && connectionQuality === "good")) {
    return null;
  }
  const getStatusConfig = () => {
    if (!isOnline || connectionQuality === "offline") {
      return {
        icon: WifiOff,
        color: "bg-red-500",
        textColor: "text-red-50",
        message: "Sem conexão com a internet",
      };
    }
    if (connectionQuality === "poor") {
      return {
        icon: AlertCircle,
        color: "bg-yellow-500",
        textColor: "text-yellow-50",
        message:
          "Conexão instável - Algumas funcionalidades podem estar lentas",
      };
    }
    return {
      icon: CheckCircle,
      color: "bg-emerald-500",
      textColor: "text-emerald-50",
      message: "Conexão restaurada",
    };
  };
  const config = getStatusConfig();
  const StatusIcon = config.icon;
  return (
    <AnimatePresence>
      {(showStatus || !isOnline || connectionQuality === "poor") && (
        <motion.div
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -50 }}
          className={`fixed top-4 left-1/2 transform -translate-x-1/2 z-50 ${config.color} ${config.textColor} px-4 py-2 rounded-lg shadow-lg flex items-center space-x-2 max-w-md`}
        >
          <StatusIcon className="w-4 h-4 flex-shrink-0" />
          <span className="text-sm font-medium">{config.message}</span>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
export default NetworkStatus;
